import { NavBack } from '../components/nav-back'

export const TermsView = () => {
  return (
    <div className='main_content experience_content experience_content-alt'>
      <NavBack />
      <div>
        <h1 className='heading-styled'>Terms & Conditions</h1>
        <p>(This section will be updated soon)</p>
      </div>
    </div>
  )
}
